import React from 'react';
import { Chip } from '@mui/material';
import {
  CheckBox,
  RadioButtonChecked,
  TextFields,
  Numbers,
  Star,
  ToggleOn,
} from '@mui/icons-material';
import { QuestionType, QUESTION_TYPE_CONFIGS } from '../types';

interface QuestionTypeChipProps {
  type: QuestionType | string;
  size?: 'small' | 'medium';
  variant?: 'filled' | 'outlined';
}

export const QuestionTypeChip: React.FC<QuestionTypeChipProps> = ({
  type,
  size = 'small',
  variant = 'outlined',
}) => {
  const typeConfig = QUESTION_TYPE_CONFIGS.find((config) => config.type === type);

  const getIcon = (iconName: string) => {
    const iconProps = {
      fontSize: 'small' as const,
    };

    switch (iconName) {
      case 'CheckBox':
        return <CheckBox {...iconProps} />;
      case 'RadioButtonChecked':
        return <RadioButtonChecked {...iconProps} />;
      case 'TextFields':
        return <TextFields {...iconProps} />;
      case 'Numbers':
        return <Numbers {...iconProps} />;
      case 'Star':
        return <Star {...iconProps} />;
      default:
        return <ToggleOn {...iconProps} />;
    }
  };

  if (!typeConfig) {
    return <Chip label={type} size={size} variant={variant} color="default" />;
  }

  return (
    <Chip
      icon={getIcon(typeConfig.icon)}
      label={typeConfig.label}
      size={size}
      variant={variant}
      color="primary"
    />
  );
};
